const data = {
  id: 1,
  title: 'Arrange columns A and B into complete sentences.',
  subTitle: 'Sắp xếp 2 cột A và B thành câu hoàn chỉnh.',
  question: '',
  answers: [
    {
      id: 1,
      textLeft: 'These people live in the mountains,',
      textRight: 'or you will get fat.',
    },
    {
      id: 2,
      textLeft: 'To help your community, you can join in Be a Buddy,',
      textRight: 'and people will throw rubbish into them.',
    },
    {
      id: 3,
      textLeft: "Don't eat too close to your bedtime,",
      textRight: 'but he never sells them.',
    },
    {
      id: 4,
      textLeft: 'My dad can make beautiful plieces of art from empty eggshells,',
      textRight: 'so they have a lot of fresh air.',
    },
    {
      id: 5,
      textLeft: 'Place a bin here and there,',
      textRight: 'or you can start your own activities.',
    },
  ],
};

export default data;
